/* ============================================
   NEW PROMO SECTION CAROUSEL FUNCTIONALITY
   ============================================ */

(function() {
    'use strict';

    const promoSections = document.querySelectorAll('.promo-section');
    if (promoSections.length === 0) return;

    // Initialize each promo section carousel
    promoSections.forEach((promoSection) => {
        const carousel = promoSection.querySelector('.promo-section__carousel');
        const track = promoSection.querySelector('.promo-section__carousel-track');
        const items = promoSection.querySelectorAll('.promo-section__carousel-item');
        const dots = promoSection.querySelectorAll('.promo-section__dot');
        const prevButton = promoSection.querySelector('[data-promo-prev]');
        const nextButton = promoSection.querySelector('[data-promo-next]');

        if (!carousel || !track || items.length === 0) return;

        initCarousel(promoSection, carousel, track, items, dots, prevButton, nextButton);
    });

    function initCarousel(promoSection, carousel, track, items, dots, prevButton, nextButton) {
        let currentIndex = 0;
        const itemsPerView = 2; // Show 2 products at a time
        let touchStartX = 0;
        let touchEndX = 0;

        // Calculate total items and number of slides
        const totalItems = items.length;
        const totalSlides = Math.ceil(totalItems / itemsPerView);
        const maxIndex = Math.max(0, totalSlides - 1);

        function getTrackGap() {
            const computedStyles = window.getComputedStyle(track);
            const gap = parseFloat(computedStyles.columnGap || computedStyles.gap || '0');
            return Number.isNaN(gap) ? 0 : gap;
        }

        function updateItemWidths() {
            const carouselWidth = carousel.offsetWidth;
            if (!carouselWidth) return;

            const gap = getTrackGap();
            const itemWidth = (carouselWidth - (gap * (itemsPerView - 1))) / itemsPerView;
            const safeItemWidth = itemWidth > 0 ? itemWidth : carouselWidth / itemsPerView;

            items.forEach((item) => {
                item.style.flexBasis = `${safeItemWidth}px`;
                item.style.maxWidth = `${safeItemWidth}px`;
                item.style.width = `${safeItemWidth}px`;
            });
        }

        // Update carousel position
        function updateCarousel() {
            updateItemWidths();
            const gap = getTrackGap();

            if (totalItems <= itemsPerView) {
                // If we have 2 or fewer items, don't translate
                track.style.transform = 'translateX(0)';
                return;
            }

            // Calculate the width of the carousel container
            const carouselWidth = carousel.offsetWidth;
            const pageStep = carouselWidth + gap;
            const translateX = -(currentIndex * pageStep);

            track.style.transform = `translateX(${translateX}px)`;
        }

        // Show specific slide
        function showSlide(index) {
            if (index < 0 || index > maxIndex) return;

            currentIndex = index;
            updateCarousel();
            updateDots();
        }

        // Go to specific slide
        function goToSlide(index) {
            showSlide(index);
        }

        // Update dot states
        function updateDots() {
            dots.forEach((dot, index) => {
                if (index === currentIndex) {
                    dot.classList.add('promo-section__dot--active');
                } else {
                    dot.classList.remove('promo-section__dot--active');
                }
            });
        }

        // Touch/swipe handlers
        function handleTouchStart(e) {
            touchStartX = e.changedTouches[0].screenX;
        }

        function handleTouchEnd(e) {
            touchEndX = e.changedTouches[0].screenX;
            handleSwipe();
        }

        function handleSwipe() {
            const swipeThreshold = 50; // Minimum distance for a swipe
            const diff = touchStartX - touchEndX;

            if (Math.abs(diff) > swipeThreshold) {
                if (diff > 0) {
                    // Swipe left - next slide
                    if (currentIndex < maxIndex) {
                        goToSlide(currentIndex + 1);
                    }
                } else {
                    // Swipe right - previous slide
                    if (currentIndex > 0) {
                        goToSlide(currentIndex - 1);
                    }
                }
            }
        }

        // Initialize this carousel
        updateCarousel();
        updateDots();

        // Set up event listeners for dots
        dots.forEach((dot, index) => {
            dot.addEventListener('click', () => goToSlide(index));
        });

        if (prevButton) {
            prevButton.addEventListener('click', () => {
                if (currentIndex > 0) {
                    goToSlide(currentIndex - 1);
                }
            });
        }

        if (nextButton) {
            nextButton.addEventListener('click', () => {
                if (currentIndex < maxIndex) {
                    goToSlide(currentIndex + 1);
                }
            });
        }

        // Touch/swipe support
        carousel.addEventListener('touchstart', handleTouchStart, { passive: true });
        carousel.addEventListener('touchend', handleTouchEnd, { passive: true });

        // Handle window resize
        let resizeTimer;
        window.addEventListener('resize', () => {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(() => {
                updateCarousel();
            }, 250);
        });
    }

    // Initialize when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => {
            // Already initialized above, but ensure it runs after DOM is ready
        });
    }

    // Video play functionality
    const playButtons = document.querySelectorAll('[data-promo-video-play]');
    playButtons.forEach((button) => {
        button.addEventListener('click', () => {
            const videoWrapper = button.closest('.promo-section__video-wrapper');
            if (!videoWrapper) return;

            const video = videoWrapper.querySelector('.promo-section__video');
            const videoEmbed = videoWrapper.querySelector('.promo-section__video-embed iframe');

            if (video instanceof HTMLVideoElement) {
                // Direct video file
                video.play();
                button.classList.add('promo-section__play-button--hidden');

                // Hide button when video ends
                video.addEventListener('ended', () => {
                    button.classList.remove('promo-section__play-button--hidden');
                });
            } else if (videoEmbed instanceof HTMLIFrameElement) {
                // YouTube/Vimeo embed
                const src = videoEmbed.src;
                if (src.includes('autoplay=0')) {
                    videoEmbed.src = src.replace('autoplay=0', 'autoplay=1');
                } else if (!src.includes('autoplay')) {
                    videoEmbed.src = src + (src.includes('?') ? '&' : '?') + 'autoplay=1';
                }
                button.classList.add('promo-section__play-button--hidden');

                // Hide poster when video starts playing
                const poster = videoWrapper.querySelector('.promo-section__video-poster');
                if (poster instanceof HTMLElement) {
                    poster.style.display = 'none';
                }
                videoWrapper.setAttribute('data-video-playing', 'true');
            }
        });
    });
})();
